import React from "react";
import AssessmentGoal from "../../../molecules/Progress/AssessmentGoal/AssessmentGoal";

const Physio = ({
  mode = "view",
  isPrimary,
}: {
  mode?: "view" | "edit";
  isPrimary?: boolean;
}) => {
  return (
    <div>
      <AssessmentGoal activeTab="exercise" mode={mode} isPrimary={isPrimary} />
    </div>
  );
};

export default Physio;
